<template>
  <div v-show="!initialLoading">
    <b-modal
      data-backdrop="static"
      :hide-footer="true"
      id="invoice-create-modal"
      :clickToClose="false"
      ref="invoice-create-modal"
      size="xl"
      :style="'z-index: 2500'"
      headerClass="order-detail-header-modal pb-0"
      contentClass="flexben-container order-detail-modal"
      bodyClass="order-detail-modal"
      centered>


      <div slot="modal-header">
        <div class="row">
          <div class="col-12 d-flex justify-content-between align-items-center text-36">
            <button type="button" aria-label="Close" class="close text-danger ml-auto" @click="closeModal">×</button>
          </div>
        </div>
      </div>


      <template v-slot:default="{ hide }">
        <div class="container-bg-white mb-3">
          <div class="row mb-4 ml-2">
            <div class="col-12 text-18 font-weight-bold pt-2">
              {{$t("flexben.invoice.invoice_create.buttons.create")}}
            </div>
          </div>

          <hr>
          <div class="row mb-2 ml-2 grey-card">
            <div class="col-12 col-md-6 mb-4 align-items-center d-flex">
              <label for="select_company" class="form-label mr-4 font-weight-bold">
                {{ $t("flexben.invoice.invoice_details.details_data.filters.company") }}
              </label>
              <select class="form-control" v-model="params.company" id="select_company" @change="loadList">
                <option :value="null">{{ $t("flexben.general.all") }}</option>
                <option v-for="company in companies" :key="company.id" :value="company.id">
                  {{ company.name }}
                </option>
              </select>
            </div>
          </div>
          <hr>
          <div class="row mb-2 ml-2 mr-2">
            <div class="col-12 text-16 font-weight-bold">
              {{$t("flexben.invoice.invoice_details.details_data.filters.title")}}
            </div>
            <div class="col-4 col-md-3 mb-2">
              <label for="select_partner" class="form-label mr-4 font-weight-bold">
                {{ $t("flexben.invoice.invoice_details.details_data.filters.partner") }}
              </label>
              <select class="form-control" v-model="params.partner" id="select_partner">
                <option :value="null">{{ $t("flexben.general.all") }}</option>
                <option v-for="partner in filterOptions.partners" :key="partner.id" :value="partner.id">
                  {{ partner.name }}
                </option>
              </select>
            </div>
            <div class="col-4 col-md-3 mb-2">
              <label for="select_type" class="form-label mr-4 font-weight-bold">{{
                $t("flexben.invoice.invoice_details.details_data.filters.benefit")
                }}</label>
              <select class="form-control" v-model="params.benefitType" id="select_type">
                <option :value="null">{{$t("flexben.general.all")}}</option>
                <option v-for="subType in filterOptions.benefit_sub_types" :key="subType" :value="subType">
                  {{$t("flexben.benefit.sub_types." + subType )}}
                </option>
              </select>
            </div>
            <div class="col-4 col-md-3 mb-0">
              <label class="col-form-label" for="start_date">{{$t("flexben.reports.inputLabels.startDate")}}</label>
              <div class="w-100 d-inline-flex">
                <label for="start_date" class="my-auto mr-2 col-form-label">
                  <font-awesome-icon icon="calendar-alt" class="text-24"/>
                </label>
                <vue-datepicker :format="dateFormat"
                                :inputClass="'form-control-d m-0 w-100 background-white'"
                                v-model="params.startDate"
                                valueType="format"
                                :class="'w-100'"
                                key="start_date"
                                id="start_date">
                </vue-datepicker>
                <img class="cursor-pointer ml-2" alt="x" src="@/assets/images/flexben/table-remove-button.svg"
                     @click="function (){params.startDate=null;}"/>
              </div>
            </div>
            <div class="col-4 col-md-3 mb-0">
              <label class="col-form-label" for="end_date">{{$t("flexben.reports.inputLabels.endDate")}}</label>
              <div class="w-100 d-inline-flex">
                <label for="end_date" class="my-auto mr-2 col-form-label">
                  <font-awesome-icon icon="calendar-alt" class="text-24"/>
                </label>
                <vue-datepicker :format="dateFormat"
                                :inputClass="'form-control-d m-0 w-100 background-white'"
                                v-model="params.endDate"
                                valueType="format"
                                :class="'w-100'"
                                key="end_date"
                                id="end_date">
                </vue-datepicker>
                <img class="cursor-pointer ml-2" alt="x" src="@/assets/images/flexben/table-remove-button.svg"
                     @click="function (){params.endDate=null;}"/>
              </div>
            </div>
          </div>

          <hr>


        </div>
        <div class="container-bg-white mb-4">
          <div class="row px-3 pt-3">
            <div class="col-3 col-md-3 d-flex align-items-center mb-2">
              <button class="btn btn-themed px-4 mr-2 mt-2"
                      @click="loadList()">
                {{ $t("flexben.invoice.invoice_details.details_data.buttons.apply_filters") }}
              </button>
            </div>
            <div class="col-3 col-md-3 d-flex align-items-center mb-2">
              <button class="btn btn-themed px-4 mr-2 mt-2" :disabled="!companySelected || !canInvoice"
                      @click="sendInvoice()">
                {{ $t("flexben.invoice.invoice_details.details_data.buttons.create") }}
              </button>
            </div>
            <div class="col-3 col-md-3 d-flex align-items-center mb-2">
              <button class="btn btn-themed px-4 mr-2 mt-2" :disabled="!companySelected" :class="{'btn-themed-red' : !canInvoice}"
                      @click="saveVAT()">
                {{ $t("flexben.invoice.invoice_details.details_data.buttons.save") }}
              </button>
            </div>

            <div v-if="companySelected && canCheckSubscription" class="col-3 col-md-3 d-flex align-items-center mb-2">
              <button class="btn btn-themed px-4 mr-2 mt-2" :disabled="checkedSubscription"
                      @click="function (){checkedSubscription=true;}">
                {{ $t("flexben.invoice.invoice_details.details_data.buttons.add_subscription") }}
              </button>
            </div>
          </div>
          <div v-if="errorFields.datePeriod" class="btn-themed-red mb-2 ml-2 ">
            <p>{{ $t("flexben.invoice.invoice_create.error_messages.date_period") }}</p>
          </div>
          <div class="row px-3 pt-3">
            <div class="col-4 col-md-4 align-items-center mb-2 ml-2 grey-card">
              <label class="m-0 form-fields col-form-label bold" for="description">
                {{ $t('flexben.invoice.invoice_details.details_data.details') }}</label>
              <input id="description" v-model="description"
                     class="form-control  m-0 w-100 background-grey border-box"
                     type="text" maxlength="200">
            </div>
            <div class="d-inline-flex col-3 col-md-3 align-items-center mb-2 ml-2 grey-card">
              <label class="col-form-label mr-2" for="invoice_start_date">{{$t("flexben.reports.inputLabels.startDate")}}</label>

              <vue-datepicker :format="dateFormat"
                              :inputClass="'form-control-d m-0 w-100 background-white'"
                              v-model="invoiceStartDate"
                              valueType="format"
                              :class="'w-100'"
                              key="invoice_start_date"
                              id="invoice_start_date">
              </vue-datepicker>
              <img class="cursor-pointer ml-2" alt="x" src="@/assets/images/flexben/table-remove-button.svg"
                   @click="function (){invoiceStartDate=null;}"/>
            </div>
            <div class="d-inline-flex col-3 col-md-3 align-items-center mb-2 ml-2 grey-card">
              <label class="col-form-label mr-2" for="invoice_end_date">{{$t("flexben.reports.inputLabels.endDate")}}</label>

              <vue-datepicker :format="dateFormat"
                              :inputClass="'form-control-d m-0 w-100 background-white'"
                              v-model="invoiceEndDate"
                              valueType="format"
                              :class="'w-100'"
                              key="invoice_end_date"
                              id="invoice_end_date">
              </vue-datepicker>
              <img class="cursor-pointer ml-2" alt="x" src="@/assets/images/flexben/table-remove-button.svg"
                   @click="function (){invoiceEndDate=null;}"/>
            </div>
          </div>
        </div>
        <div v-if="companySelected && checkedSubscription" class="container-bg-white mb-2">
          <div class="row mb-4 ml-2">
            <div class="col-2 col-md-2 text-18 font-weight-bold pt-2">
              <img class="cursor-pointer ml-2 mr-2" alt="x" src="@/assets/images/flexben/table-remove-button.svg"
                   @click="function (){checkedSubscription=false; subscriptionProduct=null;}"/>
              {{$t("flexben.invoice.invoice_create.subscription.title")}}
            </div>
          </div>
          <div class="row mb-4 ml-2 mr-2 ">
            <div  v-if="subscriptionProduct && parseInt(subscriptionProduct.identifier) === 1"  class="col-3 col-md-3 text-bold background-grey">
              <label for="users"
                     class="col-form-label mr-4 p-0 mb-2 text-16 text-bold">
                {{$t("flexben.invoice.invoice_create.subscription.users")}}

              </label>
              <input v-model.number="subscription.quantity" type="number" class="w-input display-inline-block square-input"
                     @wheel.prevent
                     name="users" data-name="users"
                     placeholder="NR" id="users" required>

            </div>
            <div  v-if="subscriptionProduct && parseInt(subscriptionProduct.identifier) === 2"  class="col-3 col-md-3 text-bold background-grey">
              <label for="users"
                     class="col-form-label mr-4 p-0 mb-2 text-16 text-bold">
                <div class="col-12 text-18 font-weight-bold pt-2">
                  {{$t("flexben.invoice.invoice_create.subscription.company")}}
                </div>


              </label>
            </div>


          </div>
        </div>

        <div v-if="companySelected" class="container-bg-white mb-2">

          <div class="row ml-2">
            <div class="col-12 text-18 font-weight-bold pt-2">
              {{$t('flexben.invoice.invoice_create.subscription.invoice_settings')}}
            </div>
          </div>
          <div class="row mb-4 ml-2 mr-2 mb-2">

            <div class="col-3 col-md-3 grey-card text-bold mb-4">

              <label for="non_legislated_benefit_subscription_included"
                     class="col-form-label mr-4 p-0 mb-2 text-16 text-bold">
                {{$t("flexben.clients.invoice.subscription_type_included")}}

              </label>
              <b-form-checkbox id="non_legislated_benefit_subscription_included" class="cursor-pointer ml-2 mr-3"
                               switch
                               :disabled="!invoiceConfig.default"
                               v-model="invoiceConfig.subscription_included">
              </b-form-checkbox>
            </div>
            <div class="col-3 col-md-3 grey-card mb-4">
              <b-tooltip :target="'invoice_only_employees'" variant="flexben" placement="topleft">
                <div v-html="$t('flexben.clients.invoice.only_active_employees_description')"
                     class="text-left"></div>
              </b-tooltip>

              <label for="invoice_only_employees" class="col-form-label mr-4 p-0 mb-2 text-16 text-bold">
                {{$t("flexben.clients.invoice.only_active_employees")}}
              </label>
              <b-form-checkbox id="only_active_employees" class="cursor-pointer ml-2 mr-3"
                               switch
                               :disabled="!invoiceConfig.default"
                               v-model="invoiceConfig.only_active_employees">
              </b-form-checkbox>

            </div>

            <div class="col-3 col-md-3 grey-card mb-4">
              <label for="non_legislated_benefit_invoice_type"
                     class="col-form-label mr-4 p-0 text-16 text-bold">
                {{$t("flexben.clients.invoice.invoice_type")}}
              </label>
              <div>
                <select
                  v-model="invoiceConfig.type"
                  :disabled="!invoiceConfig.default"
                  id="non_legislated_benefit_invoice_type" class="form-control">
                  <option v-for="type of filterOptions.invoice_types" :value="type" :key="type">
                    {{$t("flexben.clients.invoice.invoice_types." + type )}}
                  </option>
                </select>
              </div>
            </div>
          </div>
        </div>


        <div class="container-bg-white">

          <div class="col-12 text-18 font-weight-bold pt-2">
            {{$t("flexben.invoice.invoice_details.requests")}}
          </div>


          <div class="row px-3 pt-3">
            <div class="col-12 table-order-request">
              <div class="table-responsive mt-3 hover-table">
                <table class="table-flx table table-striped">
                  <thead>
                  <tr>
                    <td class="w-25-p"><input type="checkbox" id="check_all" v-model="checkedAll" @change="checkAll()"
                                              class="cursor-pointer"/>
                    </td>
                    <td>
                      {{ $t("flexben.requests.table.header.number") }}
                    </td>
                    <td>
                      {{ $t("flexben.requests.table.header.placed_on") }}
                    </td>
                    <td>{{ $t("flexben.requests.table.header.beneficiary") }}</td>
                    <td style="width: 150px;">{{ $t("flexben.requests.table.header.beneficiary_cnp") }}</td>
                    <td style="width: 150px;" v-if="!params.company">{{ $t("flexben.requests.table.header.client") }}
                    </td>
                    <td>{{ $t("flexben.requests.table.header.benefit") }}</td>
                    <td>{{ $t("flexben.requests.table.header.status") }}</td>
                    <td>{{ $t("flexben.requests.table.header.partner") }}</td>
                    <td>{{ $t("flexben.requests.table.header.platform_source") }}</td>
                    <td style="width: 150px;">
                      {{ $t("flexben.requests.table.header.amount") }}
                    </td>
                    <td style="width: 150px;">
                      {{ $t("flexben.requests.table.header.vat_percent") }}
                    </td>
                    <td style="width: 150px;">
                      {{ $t("flexben.requests.table.header.vat_amount") }}
                    </td>
                  </tr>
                  </thead>
                  <tbody class="display-inline-block">
                  <template v-if="list.data.length >0">
                    <tr class="trhover"
                        v-for="(item, index) in list.data" :key="item.order_request_id">
                      <td class="w-25-p">
                        <input :checked="checkIds.includes(item.id)" type="checkbox"
                               @change="selectForInvoice(item)" class="cursor-pointer"/>
                      </td>
                      <td>{{ item.id }}</td>
                      <td>{{ moment(item.placed_at, 'DD/MM/YYYY HH:mm') }}</td>
                      <td>{{ (item.company_employee ? item.company_employee.first_name : '') + ' ' +
                        (item.company_employee ? item.company_employee.last_name : ' .,-') }}
                      </td>
                      <td>{{ (item.company_employee ? item.company_employee.cnp : '') }}</td>
                      <td v-if="!params.company">{{ item.company.name }}</td>
                      <td>
                        <span class="color-bullet mr-1"></span>
                        {{ item.benefit ? item.benefit.name : '-' }}
                      </td>
                      <td>
                    <span class="beneficiary-request-status"
                          :class="'flx-'+item.status">{{$t("flexben.requests.summary.status_new." + item.status_new)}}
                    </span>
                      </td>
                      <td>{{ item.benefit ? (item.benefit.partner ? item.benefit.partner.name : '-' ) : '-'}}</td>
                      <td> {{item.platform_source}}</td>
                      <td>{{ item.total_value }} Lei</td>
                      <td>
                        <input v-model.number="item.vat" type="number" class="w-input display-inline-block"
                               @wheel.prevent
                               name="vat" data-name="vat" :class="{'flexben-tooltip-icon-red' : item.vat !== originalList[index].vat}"
                               placeholder="TVA" id="vat" required @keyup="checkIfVatChanged"></td>
                      <td>{{ item.vat!=0 ? calculateVatValue(item.total_value, item.vat) : 0 }} Lei</td>
                    </tr>
                  </template>
                  <template v-else>
                    <tr class="gri-cell text-center trhover">
                      <td :colspan="100" class="text-center">{{ $t("flexben.general.no_results_found") }}
                      </td>
                    </tr>
                  </template>
                  </tbody>
                </table>
              </div>
            </div>
            <div v-if="canInvoice" class="row mb-6 ml-4">
              <div class="col-6 col-md-6 d-flex text-18 font-weight-bold pt-2">
                {{ $t("flexben.invoice.invoice_create.total") + total}}
              </div>
              <div class="col-6 col-md-6 d-flex text-18 font-weight-bold pt-2">
                {{ $t("flexben.invoice.invoice_create.total_vat") + total_vat}}
              </div>
            </div>
            <div class="col-12 p-0">
              <listPagination
                :activePage="list.current_page"
                :currentPage="list.current_page"
                :totalItems="list.total"
                :startItem="list.from"
                :endItem="list.to"
                :itemsPerPage="list.perPage"
                @pageChanged="pageChanged"
                @changePerPage="changePerPage"></listPagination>
            </div>
          </div>
        </div>

      </template>


    </b-modal>
    <content-loader :loader-visible="loading" :loader-error="loaderError"></content-loader>

  </div>
</template>

<script>


import httpFlexbenService from "@/http/http-flexben";
import Datepicker from "vuejs-datepicker";
import moment from "moment";

export default {
  name: "CreateInvoice",
  components: {
    'vue-datepicker': Datepicker,
  },
  props: {
    companies: Array,
  },
  data: () => {
    return {
      httpService: httpFlexbenService.invoices,
      initialLoading: true,
      loading: true,
      loaderError: false,
      companySelected: false,
      checkedSubscription: false,
      canCheckSubscription: false,
      canInvoice: true,
      subscription:{quantity: null},
      dateFormat: 'dd/MM/yyyy',
      momentFormat: 'YYYY-MM-DD',
      invoiceConfig: {
        default: true,
        type: 1,
        only_active_employees: false,
        subscription_included: false,
      },
      total: 0,
      total_vat: 0,
      startDate: null,
      endDate: null,
      subscriptionProduct: null,
      description: null,
      invoiceStartDate: null,
      invoiceEndDate: null,
      params: {
        page: 1,
        perPage: 20,
        company: null,
        startDate: null,
        endDate: null,
        partner: null,
        benefitType: null,
      },
      errorFields: {
        datePeriod: false
      },
      checkIds: [],
      checkedAll: false,
      filterOptions: {
        page: 1,
        perPage: 20,
        companies: [],
        partners: [],
        benefit_sub_types: [],
        invoice_types: []
      },
      list: {
        data: [],
        current_page: 1,
        to: 1,
        perPage: 1,
        lastPage: 1,
        total: 1
      },
      originalList: []
    }
  },
  mounted() {
  },
  watch: {
    'params.startDate': {
      handler: function (val) {
        console.log(val)
        this.params.startDate = val ? moment(val).format(this.momentFormat) : null;
      }
    },
    'params.endDate': {
      handler: function (val) {
        this.params.endDate = val ? moment(val).format(this.momentFormat) : null;
      }
    },
    'invoiceStartDate': {
      handler: function (val) {
        this.invoiceStartDate = val ? moment(val).format(this.momentFormat) : null;

        if ((!this.invoiceStartDate || !this.invoiceEndDate) && this.checkIds.length === 0) {
          this.errorFields.datePeriod = true;
        } else {
          this.errorFields.datePeriod = false;
        }
      }
    },
    'invoiceEndDate': {
      handler: function (val) {
        this.invoiceEndDate = val ? moment(val).format(this.momentFormat) : null;

        if ((!this.invoiceStartDate || !this.invoiceEndDate) && this.checkIds.length === 0) {
          this.errorFields.datePeriod = true;
        } else {
          this.errorFields.datePeriod = false;
        }
      }
    },
    'params.company': {
      handler: function (val) {
        this.companySelected = !!val;
      }
    }
  },
  methods: {
    loadList() {
      this.loading = true;

      this.httpService.getOrderRequests(this.params)
        .then((response) => {
          return response.data;
        })
        .then((data) => {
          let items = data.data;
          let filters = data.filters;

          this.list = {
            data: items.data,
            current_page: items.current_page,
            to: items.to,
            perPage: items.perPage,
            lastPage: items.lastPage,
            total: items.total
          };
          this.originalList = JSON.parse(JSON.stringify(this.list.data));


          this.filterOptions.benefit_sub_types = filters.benefit_sub_types;
          this.filterOptions.partners = filters.partners;
          this.filterOptions.invoice_types = filters.invoice_types;
          this.subscriptionProduct = data.subscriptionProduct;

          if (data.invoiceConfig) {
            this.invoiceConfig.default = true;
            this.invoiceConfig.type = data.invoiceConfig.invoice_type;
            this.invoiceConfig.only_active_employees = data.invoiceConfig.only_active_employees;
            this.invoiceConfig.subscription_included = data.invoiceConfig.subscription_included;
          }
          if (this.subscriptionProduct) {
            if (this.subscriptionProduct.identifier === 2) {
              this.subscription.quantity = 1;
            }

            this.canCheckSubscription = true;
          }

          this.loading = false;
          this.initialLoading = false;
          this.openModal();
        })
        .catch((error) => {
          this.list = {
            data: [],
            current_page: 1,
            to: 1,
            perPage: 1,
            lastPage: 1,
            total: 1
          };
          console.log(error)
          if (error.response.status >= 500 && error.response.status < 600) {
            this.loading = false;
            this.loaderError = true;
            this.initialLoading = false;
          }
        });
    },
    show() {
      this.initialLoading = false;
      this.loadList();
    },
    closeModal() {
      this.resetModal();
      this.$refs['invoice-create-modal'].hide();
      this.$emit('loadIndex');
    },
    resetModal() {
      this.params = this.$options.data.call(this).params;
      this.filterOptions = this.$options.data.call(this).filterOptions;
      this.subscription = this.$options.data.call(this).subscription;
      this.list = this.$options.data.call(this).list;
      this.companySelected = false;
      this.checkedSubscription = false;
      this.canCheckSubscription = false;
      this.canInvoice = true;
      this.subscriptionProduct = null;
      this.description = null;
      this.checkedAll = false;
      this.checkIds = [];
    },
    openModal() {
      this.$refs['invoice-create-modal'].show();
    },
    sendInvoice() {
      this.loading = true;
      let payload = {};
      payload.company_id = this.params.company;
      payload.request_ids = this.checkIds;
      payload.description = this.description;
      payload.start_date = this.invoiceStartDate;
      payload.end_date = this.invoiceEndDate;

      if (this.invoiceConfig.default) {
         payload.invoice_config = this.invoiceConfig;
      }

      if (this.checkedSubscription) {
        if (this.subscriptionProduct.identifier == 2) {
          this.subscription.quantity = 1;
        }
        payload.subscription = this.subscription;
      }

      if (!this.validatePayload(payload)) {
        this.loading = false;
        return;
      }

      this.httpService.createInvoice(payload)
        .then((response) => {
          return response.data;
        })
        .then((data) => {
          this.loading = false;

          this.closeModal()
        })
        .catch((error) => {
          if (error.response.status >= 500 && error.response.status < 600) {
            this.loading = false;
            this.loaderError = true;
            this.initialLoading = false;
          }
          this.closeModal()
        });

    },
    selectForInvoice(item) {

      let index = this.checkIds.indexOf(item.id);
      if (index === -1) {
        this.checkIds.push(item.id);

        this.total += item.total_value;
        this.total_vat += item.vat_value;
      } else {
        this.checkIds.splice(index, 1);

        this.total -= item.total_value;
        this.total_vat -= item.vat_value;
      }
    },
    saveVAT() {
      this.loading = true;
      let changedItems = this.list.data.filter((item, index) =>
        item.vat !== this.originalList[index].vat
      ).map(item => ({
        id: item.id,
        vat: item.vat
      }));

      let payload = {};
      payload.items = changedItems;

      this.httpService.saveVat(payload)
        .then((response) => {
          return response.data;
        })
        .then((data) => {
          this.canInvoice = true;
          this.loading = false;
        })
        .catch((error) => {
          if (error.response.status >= 500 && error.response.status < 600) {
            this.loading = false;
            this.loaderError = true;
            this.initialLoading = false;
          }
        });

    },
    checkIfVatChanged() {
      let changedItems = this.list.data.filter((item, index) =>
        item.vat !== this.originalList[index].vat
      ).map(item => ({
        id: item.id,
        vat: item.vat
      }));

      if (changedItems.length === 0) {
        this.canInvoice = true;
        return;
      }

      this.canInvoice = false;
    },
    changePerPage(perPage) {
      this.params.page = 1;
      this.params.perPage = perPage;
      this.loadList();
    },
    pageChanged(page) {
      this.params.page = page;
      this.loadList();
    },
    checkAll() {
      let total = 0;
      let total_vat = 0;
      if (!this.checkedAll) {
        this.checkIds = [];
        total = 0;
        total_vat = 0;
      } else {
        this.list.data.forEach((item) => {
          this.checkIds.push(item.id);
          total += item.total_value;
          total_vat += item.vat_value;
        })
      }

      this.total = total;
      this.total_vat= total_vat;
    },
    calculateVatValue(price, vat) {
      let result = price - (price / (1 + (vat / 100)));
      return Number(result.toFixed(2));
    },
    resetPagination() {
      this.params.page = 1;
      this.params.perPage = 20;
    },
    addSubscription() {
      this.checkedSubscription = true;
    },
    validatePayload(payload) {
      if (!this.checkIds.length && !this.checkedSubscription) {
         return false;
      }

      if (!payload.start_date || !payload.end_date) {
         if (!payload.request_ids.length) {
           this.errorFields.datePeriod = true;
           return false;
         }

      }

      return true;
    },
  }
}
</script>

<style scoped>

</style>
